import React, { useEffect, useRef } from 'react';
import { createHub } from './controller';
import { createQaConfig } from './config';
import './QaPage.less';

const QaPage: React.FC = () => {
  const pageRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const page = pageRef.current;
    if (!page) return undefined;
    const hub = createHub({
      window,
      document: {
        getElementById: (id) => page.querySelector<HTMLElement>(`[id="${id}"]`),
        createElement: document.createElement.bind(document),
      },
      fetch: (...args) => window.fetch(...args),
      config: createQaConfig(window.location.origin),
    });
    return () => hub.dispose();
  }, []);

  return (
    <div ref={pageRef} className="qa-hub">
      <header className="qa-header">
        <div><span className="qa-eyebrow">eSmart Plan · Internal QA</span><h1>QA Hub</h1></div>
        <button id="logout" type="button" hidden>Sign out of QA Hub</button>
      </header>
      <main>
        <p id="status" className="qa-status" role="status" aria-live="polite">Preparing QA Hub…</p>
        <section id="loginPanel" className="qa-card" aria-labelledby="loginTitle" hidden>
          <h2 id="loginTitle">Sign in to test</h2>
          <p>Use your test API account. Reloading this page requires a new sign-in.</p>
          <form id="loginForm">
            <label>Test environment<select id="profile" required /></label>
            <label>Username<input id="username" autoComplete="username" required /></label>
            <label>Password<input id="password" type="password" autoComplete="current-password" required /></label>
            <div className="qa-actions"><button id="signIn" className="qa-primary" type="submit">Sign in</button><button id="cancelLogin" type="button" hidden>Cancel</button></div>
          </form>
        </section>
        <section id="workspace" hidden>
          <div className="qa-workspace">
            <aside className="qa-card qa-controls" aria-label="Widget controls">
              <h2>Test context</h2><p id="environment" />
              <label>Ticker<input id="ticker" placeholder="Enter ticker for Analysis" autoComplete="off" /></label>
              <label>Market<select id="mkt" defaultValue="JP"><option value="JP">JP</option><option value="US">US</option></select></label>
              <div className="qa-actions"><button id="presetJp" type="button">6269 · JP</button><button id="presetUs" type="button">AAPL · US</button></div>
              <details><summary>Optional context</summary>
                <label>RIC<input id="ric" autoComplete="off" /></label>
                <label>Locale<input id="locale" placeholder="e.g. ja" autoComplete="off" /></label>
                <label>Theme<input id="theme" placeholder="e.g. light" autoComplete="off" /></label>
              </details>
              <h2>Screens</h2><nav id="catalog" aria-label="QA screen catalog" />
              <p className="qa-help">Select a screen to load it. Editing context alone does not reload the widget.</p>
            </aside>
            <section className="qa-viewer" aria-labelledby="viewerTitle">
              <div className="qa-card qa-toolbar">
                <h2 id="viewerTitle">Widget preview</h2>
                <div className="qa-actions">
                  <label>Width<select id="width" defaultValue="626"><option value="626">Desktop · 626px</option><option value="600">600px</option><option value="599">Mobile · 599px</option><option value="375">Mobile · 375px</option><option value="360">Mobile · 360px</option><option value="fluid">Fit available width</option></select></label>
                  <label>Header offset (px)<input id="headerOffset" type="number" min="0" max="2000" defaultValue="0" /></label>
                  <button id="reload" type="button" disabled>Reload</button>
                  <button id="back" type="button" disabled>Close preview</button>
                </div>
                <p id="frameStatus" role="status" aria-live="polite">Choose a screen from the catalog.</p>
              </div>
              <div id="preview" className="qa-preview"><div id="frameMount" /></div>
              <details className="qa-card"><summary>Integration messages</summary><pre id="messages" aria-label="Accepted widget messages" /></details>
            </section>
          </div>
        </section>
      </main>
    </div>
  );
};

export default QaPage;
